import { CountryApiDto, LocaleApiDto } from '@b2x/storefront-api-js-client/src/dto';
import { Graph } from 'schema-dts';

import { ImageContentSectionV2 } from '../contentTypes';
import { getItemFromSwitch } from '../util';

export const stripHtml = (html?: string): string | undefined => {
  if (!html) {
    return undefined;
  }

  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return text || undefined;
};

export const getImageUrlFromContentV2 = (image?: ImageContentSectionV2): string | undefined => {
  const provider = getItemFromSwitch(image?.provider);

  const url =
    provider?.bcom?.xxl?.url ??
    provider?.bcom?.xl?.url ??
    provider?.bcom?.lg?.url ??
    provider?.bcom?.md?.url ??
    provider?.bcom?.sm?.url ??
    provider?.bcom?.xs?.url ??
    provider?.thron?.xxl?.url ??
    provider?.thron?.xl?.url ??
    provider?.thron?.lg?.url ??
    provider?.thron?.md?.url ??
    provider?.thron?.xs?.url;

  return url?.replace(/\u200B/g, '');
};

/*
  Lingua come tag BCP 47 (es. "it-IT"), per inLanguage.
  La regione è quella del locale se presente, altrimenti il paese di spedizione; senza nessuna delle due resta la sola lingua.
*/
export const getLanguageTag = (locale?: LocaleApiDto, shippingCountry?: CountryApiDto): string | undefined => {
  if (!locale) {
    return undefined;
  }
  const region = locale.countryCode ?? shippingCountry?.code;
  return region ? `${locale.languageCode}-${region.toUpperCase()}` : locale.languageCode;
};

/*
  Script JSON-LD per Helmet senza le entità HTML che helmetJsonLdProp applica a tutte le stringhe:
  il contenuto di uno script ld+json non viene decodificato, quindi "&" in hasMap diventerebbe "&amp;" alla lettera.
  Basta l'escape di "<" (come raccomandato da JSON-LD 1.1) per non chiudere lo script; i null vengono omessi come in helmetJsonLdProp.
*/
export const jsonLdScriptProp = (graph: Graph) => ({
  innerHTML: JSON.stringify(graph, (_key, value: unknown) => (value === null ? undefined : value), 1).replace(
    /</g,
    '\\u003c'
  ),
  type: 'application/ld+json',
});
